import Sortable from "sortablejs";

// Auto sort control
const sortOperations = {
    name: function(a, b) {
        const aName = a.getAttribute('data-name').trim().toLowerCase();
        const bName = b.getAttribute('data-name').trim().toLowerCase();
        return aName.localeCompare(bName);
    },
    created: function(a, b) {
        const aTime = Number(a.getAttribute('data-created'));
        const bTime = Number(b.getAttribute('data-created'));
        return bTime - aTime;
    },
    updated: function(a, b) {
        const aTime = Number(a.getAttribute('data-updated'));
        const bTime = Number(b.getAttribute('data-updated'));
        return bTime - aTime;
    },
    chaptersFirst: function(a, b) {
        const aType = a.getAttribute('data-type');
        const bType = b.getAttribute('data-type');
        if (aType === bType) {
            return 0;
        }
        return (aType === 'chapter' ? -1 : 1);
    },
    chaptersLast: function(a, b) {
        const aType = a.getAttribute('data-type');
        const bType = b.getAttribute('data-type');
        if (aType === bType) {
            return 0;
        }
        return (aType === 'chapter' ? 1 : -1);
    },
};

class DocumentSort {

    constructor(elem) {
        this.elem = elem;
        this.sortContainer = elem.querySelector('[document-sort-boxes]');
        this.submitUrl = window.baseUrl(`/ajax/savedocumentsort`);
        this.initialSortBox = elem.querySelector('.document-sort-box');

        this.sortToggleButton = document.getElementById('btnDocumentSortToggle');
        this.sortToggleButtonText = document.getElementById("spanDocumentSortText");
        this.spanDocumentSortTextEnable = document.getElementById("spanDocumentSortTextEnable");
        this.spanDocumentSortTextDisable = document.getElementById("spanDocumentSortTextDisable");
        this.EnableSortingText = this.spanDocumentSortTextEnable ? this.spanDocumentSortTextEnable.innerHTML : 'Sorteren inschakelen';
        this.DisableSortingText = this.spanDocumentSortTextDisable ? this.spanDocumentSortTextDisable.innerHTML : 'Schakel sorteren uit';

        this.sortToggleButtonText.innerHTML = this.EnableSortingText;
        this.sortToggleButton.addEventListener('click', this.handleSortAction.bind(this));

        this.setupBookSortable(this.initialSortBox, this.disableStatus);
    }

    handleSortAction(event) {
        var sortableElement = document.getElementById("documentSortList");
        var sortable = Sortable.get(sortableElement);
        var sortableState = sortable.option("disabled"); // get

        sortable.option("disabled", !sortableState); // set
        this.sortToggleButtonText.innerHTML = sortableState ? this.DisableSortingText : this.EnableSortingText;
    }

    /**
     * Setup the given book container element to have sortable items.
     * @param {Element} bookContainer
     */
    setupBookSortable(bookContainer) {
        const sortElems = [bookContainer.querySelector('.sort-list')];
        sortElems.push(...bookContainer.querySelectorAll('.entity-list-item + ul'));

        for (let sortElem of sortElems) {
            new Sortable(sortElem, {
                animation: 150,
                fallbackOnBody: true,
                swapThreshold: 0.65,
                onSort: this.updateDocumentMapInput.bind(this),
                dragClass: 'bg-white',
                ghostClass: 'primary-background-light',
                multiDrag: true,
                multiDragKey: 'CTRL',
                selectedClass: 'sortable-selected',
                disabled: true
            });
        }
    }

    /**
     * Update the input with our sort data.
     */
    updateDocumentMapInput() {
        const documentMap = this.buildDocumentMap();

        let reqData = {
            sortData: documentMap
        };
        window.$http.post(this.submitUrl, reqData).then(resp => {
            // set updated sidebar menu after sorting
            var divBookTree = document.getElementById("book-tree");
            divBookTree.parentElement.innerHTML = resp.data;
        }).catch(err => {
            window.$events.showValidationErrors(err);
        });
    }

    /**
     * Build up a mapping of entities with their ordering and nesting.
     * @returns {Array}
     */
    buildDocumentMap() {
        const documentMap = [];
        const lists = this.elem.querySelectorAll('.sort-list');

        for (let list of lists) {
            for (let i = 0; i < list.children.length; i++) {
                const bookId = list.children[i].getAttribute('data-entity-id');

                documentMap.push({
                    book_id: bookId,
                    sort_index: i,
                    type: 'book',
                });
            }
        }

        return documentMap;
    }
}

export default DocumentSort;
